import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import LinkButton from './LinkButton';
import { ArrowBackIcon } from '../../../ui';
import { Color } from '../../../styles/Color';

interface IBackLinkProps {
	backLink: string;
	ariaLabel?: string;
	children?: ReactNode;
}

export default function BackLink({
	backLink,
	ariaLabel,
	children,
}: IBackLinkProps) {
	return (
		<StyledLinkButton
			href={backLink}
			buttonType="text"
			icon={<ArrowBackIcon aria-hidden="true" />}
			aria-label={ariaLabel || 'Go back to previous page'}
			iconPosition="left"
		>
			{children}
		</StyledLinkButton>
	);
}

const StyledLinkButton = styled(LinkButton)`
	color: ${Color.OnBackground};

	&:hover {
		color: ${Color.OnBackground};
	}
`;
